<button
  class="btn"
  [atxPopover]="suggestProducts"
  [popoverPlacement]="popoverPlacement"
  (mouseenter)="preloadProducts()"
>
  @if(isDesktop()) {
  <span
    i18n="
      Pbasket|Pbasket bought this season products
      button@@pbasketBoughtThisSeasonProductsButton"
    >Most Frequently Re-Ordered by You</span
  >
  } @else {
  <span
    i18n="
      Pbasket|Pbasket bought this season products button
      mobile@@pbasketBoughtThisSeasonProductsButtonMobile"
    >M</span
  >
  }
</button>

<ng-template #suggestProducts>
  <div class="popover-content_wrapper">
    <h4
      i18n="
        Pbasket|Pbasket bought this season products
        header@@pbasketBoughtThisSeasonProductsHeader"
      class="text-center my-1 px-2"
    >
      Most Frequently Re-Ordered By You
    </h4>

    @if (isLoading()) {
    <atx-loader-overlay
      i18n-loaderText="Pcard|Similar products loading@@loadingSimilarProducts"
      loaderText="Loading products..."
      [type]="overlayType"
      class="overlay flex-1"
    ></atx-loader-overlay>
    } @else if (hasError()) {
    <span
      i18n="PCard|Load similar error text@@similarProductsError"
      class="text-danger font-size-lg font-weight-bold m-auto"
    >
      An unexpected error occurred.
    </span>
    } @else if (products()?.length > 0) {
    <div class="products_wrapper">
      @for (product of products(); track product.productId) {
      <atx-horizontal-product-v2
        [product]="product"
        [shownLabelsLimit]="3"
        (click)="onProductClick(product)"
      ></atx-horizontal-product-v2>
      }
    </div>

    } @else if (isLoaded()) {
    <span
      i18n="PCard|Load similar no products text@@pcardSimilarNoProductsText"
      class="font-size-lg font-weight-bold m-auto"
    >
      No available products
    </span>
    }
  </div>
</ng-template>
